import React, { useState, useEffect } from "react";
import "./Experiences.css";
import BackBtnSvg from "../../assets/ReactSvg/BackBtnSvg";
import classNames from "classnames";
import { Spin } from "antd";

const Experiences = ({ hostExperience, setViewExperiencePage }) => {
  const [activeExp, setActiveExp] = useState(hostExperience[0]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadedImages, setLoadedImages] = useState(0);

  const handleExperienceChange = (exp) => {
    if (activeExp.label === exp.label) return;

    setActiveExp(exp);
    setIsLoading(true);
    setLoadedImages(0);
  };

  useEffect(() => {
    if (loadedImages === activeExp.photos.length) {
      setTimeout(() => setIsLoading(false), 300);
    }
  }, [loadedImages, activeExp.photos.length]);

  return (
    <div className="experiences-container">
      <div className="experiences-header-wrapper">
        <div className="experiences-header">
          <button
            onClick={() => setViewExperiencePage(false)}
            type="button"
            className="btn back-btn experiences-header-btn"
          >
            <BackBtnSvg />
          </button>
          <div className="experiences-header-content Satoshi">Experiences</div>
        </div>

        <div className="experiences-tabs">
          {hostExperience.map((exp) => (
            <span
              key={exp.label}
              onClick={() => handleExperienceChange(exp)}
              className={classNames("Satoshi experiences-tab", {
                "experiences-tab-active": activeExp.label === exp.label,
              })}
            >
              {exp.label}
            </span>
          ))}
        </div>
      </div>

      {isLoading && (
        <div className="gallery-loader">
          <Spin size="large" />
        </div>
      )}

      <div className="gallery" style={{ opacity: isLoading ? 0 : 1 }}>
        {activeExp.photos.map((item, index) => {
          const isVideo =
            item.endsWith(".mp4") ||
            item.endsWith(".mov") ||
            item.endsWith(".webm");

          return (
            <div key={index} className="grid-item small">
              {isVideo ? (
                <video
                  src={item}
                  className="media-experience-gallery-video"
                  controls
                  playsInline
                  onLoadedData={() => setLoadedImages((prev) => prev + 1)}
                />
              ) : (
                <img
                  src={item}
                  alt="img"
                  className="media-experience-gallery"
                  onLoad={() => setLoadedImages((prev) => prev + 1)}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Experiences;
